import { isCapabilityEnabled } from 'owa-capabilities';
import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Remove reference to getHostValue
 *	> While generally we don't want to use getHostValue in code - it is acceptable to use in a capability as it clearly ties back to the feature needing it. */
import { NATIVE, getHostValue } from 'owa-config';
import { newHeaderCapability } from './newHeaderCapability';
import { novaMeControlCapability } from './novaMeControlCapability';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to check in which platforms the header Me control is enabled.
 * It is supported by default native platform where the novaMeControlCapability is enabled.
 * Additionally, it is also supported in web platform when the newHeaderCapability is enabled.
 * The capability is enabled when is supported and the UniversalMeControl application setting is enabled.
 */
export const headerMeControlCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return (
            isCapabilityEnabled(novaMeControlCapability) ||
            (getHostValue() !== NATIVE && isCapabilityEnabled(newHeaderCapability))
        );
    },
};
